import ChartDatasets from "./datasets/dataset_helper"
import ChartOptions from "./options/options"
export default {
    name: "CostChartComponent",
    datasets: [],
    labels: "months",
    loading: true,
    style:"height: 150px",
    options: ChartOptions.getCostChartOptions(),
    config: {
        datasets: {
            today: {
                borderColor: "#a1704b",
            },
            yesterday: {
                borderColor: "#d2a17d",
            }
        }

    }
}